import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuditType {
  inActive: boolean;
  inActiveReason: string;
  inActiveBy: string;
  inActiveDate: string;
  addedBy: string;
  addedDate: string;
  updatedBy: string;
  updatedDate: string;
  id: number;
  auditTypeName: string;
  description: string;
}

interface AuditTypeState {
  auditTypes: AuditType[];
  loading: boolean;
  error: string | null;
}

const initialState: AuditTypeState = {
  auditTypes: [],
  loading: false,
  error: null,
};

const auditTypeSlice = createSlice({
  name: 'auditType',
  initialState,
  reducers: {
    setAuditTypes: (state, action: PayloadAction<AuditType[]>) => {
      state.auditTypes = action.payload;
    },
    addAuditType: (state, action: PayloadAction<AuditType>) => {
      state.auditTypes.push(action.payload);
    },
    updateAuditType: (state, action: PayloadAction<AuditType>) => {
      const index = state.auditTypes.findIndex(type => type.id === action.payload.id);
      if (index !== -1) {
        state.auditTypes[index] = action.payload;
      }
    },
    deleteAuditType: (state, action: PayloadAction<number>) => {
      state.auditTypes = state.auditTypes.filter(type => type.id !== action.payload);
    },
  },
});

export const { 
  setAuditTypes, 
  addAuditType, 
  updateAuditType, 
  deleteAuditType 
} = auditTypeSlice.actions;

export default auditTypeSlice.reducer; 